import {Component} from '@angular/core';

@Component({
    selector: 'app-forbidden',
    templateUrl: './forbidden.component.html',
    standalone: false,
})
export class ForbiddenComponent {}
